import { postSubscribe } from 'api/platform/homepage.js'

export default {
  data: {
    token: ''
  },
  computed: {
    mixinIsApp() {
      const { isYixinliApp, isZiXunApp, isZiXunShiApp } = this.$platform
      return isYixinliApp || isZiXunApp || isZiXunShiApp
    }
  },
  methods: {
    async mixinGetToken() {
      if (this.$platform.isYixinliApp) {
        const { token } = await this.$bridge.getToken()
        return token
      } else {
        const { token } = await this.$store.dispatch('getUserInfo')
        return token
      }
    },
    mixinToggleFollow(autoCancel) {
      if (this.followPending) return
      this.followPending = true

      this.mixinGetToken()
        .then(token => {
          const params = {
            token,
            objectType: 10, // 关注对象类型，8=话题，10=用户
            objectId: this.$route.params.userId
          }
          return postSubscribe(params)
        })
        .then(({ code, data, message }) => {
          if (code == 0) {
            if (+data.subscribeState === 1) {
              this.$toast('关注成功')
              this.$trackEvent('newprofilepages_follow_success', {})
            } else {
              !autoCancel && this.$toast('已取消关注')
            }
            // 更新状态
            this.$store.dispatch('homepage/fetchUserRelation', {
              user_id: this.$route.params.userId
            })
            this.$store.dispatch('homepage/fetchBasicInfo', {
              user_id: this.$route.params.userId
            })
          } else {
            this.$toast(message)
          }
        })
        .catch(err => {
          console.log('接口报错：', err)
          this.$toast('网络异常，请重试')
        })
        .finally(() => {
          this.followPending = false
        })
    }
  }
}
